export const PFUSCHBET_BRAND = {
  name: 'PfuschBet',
  title: 'PfuschBet',
  logo: '/pfuschbet/logo.svg',
  logoOnDark: '/pfuschbet/logo-on-dark.svg'
} as const;
